/**
 * h5页面微信分享
 * @Author   wm
 * @DateTime 2018-09-18
 * @param {Object} title：分享标题， desc：分享描述， link：分享链接 imgUrl： 分享图标
 * @returns {Promise}
 */

export interface shareInfo {
    title: string;
    desc: string;
    link: string;
    imgUrl: string;
}
export function share(args: {
    title: string;
    desc: string;
    link: string;
    imgUrl: string;
}) {
    const wxjs = window.wxjs;
    wxjs &&
        wxjs.ready(function (api: any) {
            api.share.set('appMessage', {
                ...args,
                success: function () {
                    //用户确认分享后执行的回调函数
                },
                cancel: function () {
                    //用户取消分享后执行的回调函数
                },
            });
            // 分享到朋友圈
            api.share.set('timeline', {
                ...args,
                success: function () {
                    //用户确认分享后执行的回调函数
                },
                cancel: function () {
                    //用户取消分享后执行的回调函数
                },
            });
        });
}
